import React from 'react';
import { Card, Breadcrumb, Row, Col, Table } from 'antd';
import { onGet, api } from '../../../../core/api';
import { getUrlParam, getTime } from '../../../../utils/commonUtils';
import moment from 'moment';

const { Column } = Table;

class OKExPage extends React.Component {

    constructor() {
        super();
        this.state = {
            quant: {}
        }
        this.loadData = this.loadData.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let id = getUrlParam(this.props.location.search, 'id');
        onGet(api.getOKExDetail.url(id)).then(response => {
            if (response === undefined) {
                return;
            }
            this.setState({ quant: response });
        });
    }

    render() {
        let modelStr = ['补仓量化', '趋势量化'];
        let typeStr = ['回测', '实盘'];
        let statusStr = ['未量化', '量化中', '已完成'];
        let statusStrModel = ['委托中', '量化中', '平仓中', '已完成'];
        let profitLoss = 0;
        if (this.state.quant.result) {
            JSON.parse(this.state.quant.result).forEach(q => {
                profitLoss += q.profitLoss;
            });
        }
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a href="#/coin/okex">OKEx</a></Breadcrumb.Item>
                    <Breadcrumb.Item>OKEx 量化详情</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content2">
                    <Card title="量化信息" bordered={false} >
                        <Row>
                            <Col span="12" push="4">
                                合约种类：{this.state.quant.symbol ? this.state.quant.symbol + '永续合约（$' + this.state.quant.price + "）" : undefined}
                            </Col>
                            <Col span="12" push="2">
                                量化模型：{this.state.quant.model ? modelStr[this.state.quant.model - 1] : undefined}
                            </Col>
                        </Row>
                        <Row className="box-row">
                            <Col span="12" push="4">
                                量化类型：{this.state.quant.type ? typeStr[this.state.quant.type - 1] : undefined}
                            </Col>
                            <Col span="12" push="2">
                                量化时长：{this.state.quant.status ? (this.state.quant.status === 2 ?
                                    getTime(parseInt((this.state.quant.finish_time - this.state.quant.create_time) / 1000)) :
                                    getTime(parseInt((Date.parse(new Date()) - this.state.quant.create_time) / 1000))) : undefined}
                            </Col>
                        </Row>
                        <Row className="box-row">
                            <Col span="12" push="4">
                                量化状态：{this.state.quant.status ? statusStr[this.state.quant.status] : undefined}
                            </Col>
                        </Row>
                        {/* 回测 */}
                        <div hidden={this.state.quant.type !== 1}>
                            <Row className="box-row">
                                <Col span="12" push="4">
                                    回测开始时间：{this.state.quant.back_test_begin_time ? moment(this.state.quant.back_test_begin_time).format('YYYY-MM-DD HH:mm:ss') : undefined}
                                </Col>
                                <Col span="12" push="2">
                                    回测结束时间：{this.state.quant.back_test_end_time ? moment(this.state.quant.back_test_end_time).format('YYYY-MM-DD HH:mm:ss') : undefined}
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </div>
                <div className="content2">
                    <Card title="量化参数" bordered={false} >
                        {/* 补仓量化 */}
                        {this.state.quant.model === 1 &&
                            <div>
                                <Row>
                                    <Col span="12" push="4">
                                        补仓量：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).margin_volume + '张' : undefined}
                                    </Col>
                                    <Col span="12" push="2">
                                        杠杆倍数：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).lever_rate + '倍' : undefined}
                                    </Col>
                                </Row>
                                <Row className="box-row">
                                    <Col span="12" push="4">
                                        量化最大深度：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).depth : undefined}
                                    </Col>
                                    <Col span="12" push="2">
                                        触发补仓的盈亏率：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).margin_rate * 100 + '%' : undefined}
                                    </Col>
                                </Row>
                                <Row className="box-row">
                                    <Col span="12" push="4">
                                        触发止盈的盈亏率：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).stop_profit_rate * 100 + '%' : undefined}
                                    </Col>
                                    <Col span="12" push="2">
                                        触发止损的盈亏率：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).stop_loss_rate * 100 + '%' : undefined}
                                    </Col>
                                </Row>
                            </div>
                        }
                        {/* 趋势量化 */}
                        {this.state.quant.model === 2 &&
                            <div>
                                <Row>
                                    <Col span="12" push="4">
                                        开仓量：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).open_volume + '张' : undefined}
                                    </Col>
                                    <Col span="12" push="2">
                                        杠杆倍数：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).lever_rate + '倍' : undefined}
                                    </Col>
                                </Row>
                                <Row className="box-row">
                                    <Col span="12" push="4">
                                        触发平仓的盈亏率：{this.state.quant.parameters ? JSON.parse(this.state.quant.parameters).close_rate * 100 + '%' : undefined}
                                    </Col>
                                </Row>
                            </div>
                        }
                    </Card>
                </div>
                <div className="content2">
                    <Card title="量化结果" bordered={false} extra={<span>总盈亏：{profitLoss ? profitLoss.toFixed(4) + this.state.quant.symbol : '0' + this.state.quant.symbol}</span>} >
                        {/* 补仓量化 */}
                        {this.state.quant.model === 1 &&
                            <Table dataSource={this.state.quant.result ? JSON.parse(this.state.quant.result) : undefined} pagination={false}>
                                <Column title="总盈亏" align="center" render={item => (<span>{item.profitLoss.toFixed(4) + this.state.quant.symbol}</span>)} />
                                <Column title="多单开仓均价" align="center" render={item => (<span>{'$' + item.price1}</span>)} />
                                <Column title="空单开仓均价" align="center" render={item => (<span>{'$' + item.price2}</span>)} />
                                <Column title="多单平仓均价" align="center" render={item => (<span>{'$' + item.price3}</span>)} />
                                <Column title="空单平仓均价" align="center" render={item => (<span>{'$' + item.price4}</span>)} />
                                <Column title="多单持仓量" align="center" render={item => (<span>{item.volume1 + '张'}</span>)} />
                                <Column title="空单持仓量" align="center" render={item => (<span>{item.volume2 + '张'}</span>)} />
                                <Column title="多单平仓量" align="center" render={item => (<span>{item.volume3 + '张'}</span>)} />
                                <Column title="空单平仓量" align="center" render={item => (<span>{item.volume4 + '张'}</span>)} />
                                <Column title="多单盈亏" align="center" render={item => (<span>{item.profitLoss1.toFixed(4) + this.state.quant.symbol}</span>)} />
                                <Column title="空单盈亏" align="center" render={item => (<span>{item.profitLoss2.toFixed(4) + this.state.quant.symbol}</span>)} />
                                <Column title="多单盈亏率" align="center" render={item => (<span>{(item.profitLossRate1 * 100).toFixed(2) + '%'}</span>)} />
                                <Column title="空单盈亏率" align="center" render={item => (<span>{(item.profitLossRate2 * 100).toFixed(2) + '%'}</span>)} />
                                <Column title="量化时长" align="center" render={item => (
                                    <span>{item.status === 3 ?
                                        getTime(parseInt((item.finishTime - item.startTime) / 1000)) :
                                        getTime(parseInt((Date.parse(new Date()) - item.startTime) / 1000))}</span>
                                )} />
                                <Column title="量化状态" align="center" render={item => (<span>{statusStrModel[item.status]}</span>)} />
                            </Table>
                        }
                        {/* 趋势量化 */}
                        {this.state.quant.model === 2 &&
                            <Table dataSource={this.state.quant.result ? JSON.parse(this.state.quant.result) : undefined} pagination={false}>
                                <Column title="总盈亏" align="center" render={item => (<span>{item.profitLoss.toFixed(4) + this.state.quant.symbol}</span>)} />
                                <Column title="开仓均价" align="center" render={item => (<span>{'$' + item.price1}</span>)} />
                                <Column title="平仓均价" align="center" render={item => (<span>{'$' + item.price2}</span>)} />
                                <Column title="持仓量" align="center" render={item => (<span>{item.volume1 + '张'}</span>)} />
                                <Column title="平仓量" align="center" render={item => (<span>{item.volume2 + '张'}</span>)} />
                                <Column title="盈亏率" align="center" render={item => (<span>{(item.profitLossRate * 100).toFixed(2) + '%'}</span>)} />
                                <Column title="量化时长" align="center" render={item => (
                                    <span>{item.status === 3 ?
                                        getTime(parseInt((item.finishTime - item.startTime) / 1000)) :
                                        getTime(parseInt((Date.parse(new Date()) - item.startTime) / 1000))}</span>
                                )} />
                                <Column title="量化状态" align="center" render={item => (<span>{statusStrModel[item.status]}</span>)} />
                            </Table>
                        }
                    </Card>
                </div>
            </div>
        );
    }

}

export default OKExPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/okex/OKExDetailPage.jsx